var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 79,
    viewBox: "0 0 71 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50183 55.811L13.774 50.9531M2 37.874H10.3111M6.50183 19.937L13.774 24.4213M18.6221 6.85794L23.124 14.7054M35.5906 2V10.9685M52.2127 6.85794L48.0572 14.7054M64.333 19.937L57.0609 24.4213M59.8312 37.874H68.8349M56.3683 50.9531L64.333 55.811",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2018 56.9324H47.7109M25.2018 56.9324L26.9333 62.1641M25.2018 56.9324C-13.237 3.49518 84.4422 0.59506 47.7109 56.9324M47.7109 56.9324L46.3257 62.1641M46.3257 62.1641H26.9333M46.3257 62.1641L45.2869 70.3852M26.9333 62.1641L27.6257 70.3852M27.6257 70.3852H45.2869M27.6257 70.3852C31.0887 79.3538 43.209 78.2327 45.2869 70.3852",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4741 56.9323V43.1993M39.7463 56.9323V43.1993M27.626 41.6111L30.7426 44.6006L33.513 42.3585L35.937 44.6006L39.0537 42.3585L41.4778 44.6006L44.5944 42.3585",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBulb);
export default __webpack_public_path__ + "static/media/white-bulb.7be7b2d4270bdb174d543d9c219df79d.svg";
export { ForwardRef as ReactComponent };